import styled from 'styled-components';

export const Content = styled.div(({ theme }) => ({
  display: 'flex',
  borderRadius: theme.radii.medium,
  alignItems: 'center',
  justifyContent: 'flex-start',
  cursor: 'pointer',
}));

export const Checkmark = styled.span(({ theme }) => ({
  position: 'relative',
  top: 0,
  left: 0,
  height: 16,
  width: 16,
  backgroundColor: theme.colors.bg,
  borderRadius: theme.radii.medium,
  border: `1px solid ${theme.colors.neutral[300]}`,
  boxSizing: 'border-box',
  alignSelf: 'flex-start',
  boxShadow: theme.shadows['100'],
  transition: `background ${theme.transitions.normal}, box-shadow ${theme.transitions.normal}`,

  '@media print': {
    boxShadow: 'none',
  },

  '&:after': {
    content: "'\f00c'",
    color: theme.colors.bg,
    fontWeight: 900,
    fontSize: 10,
    fontFamily: "'Font Awesome 5 Pro'",
    opacity: 0,
    transition: `opacity ${theme.transitions.normal}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 14,
    height: 14,
  },
}));

export const Container = styled.label<{ hideFocus?: boolean }>(({ theme, hideFocus }) => ({
  position: 'relative',
  userSelect: 'none',

  '&:hover': {
    [`& input:not(:disabled) ~ ${Checkmark}`]: {
      borderColor: theme.colors.primary[500],
    },

    [`${Checkmark}`]: {
      backgroundColor: theme.colors.neutral[100],
      boxShadow: theme.shadows['300'],
    },
  },

  '& input': {
    position: 'absolute',
    opacity: 0,
    cursor: 'pointer',
    height: '100%',
    width: '100%',
    zIndex: 2,

    '&:disabled': {
      [`& ~ ${Content}`]: {
        opacity: 0.5,
        cursor: 'initial',
      },

      [`& ~ ${Content} ${Checkmark}`]: {
        backgroundColor: theme.colors.neutral[400],
        borderColor: theme.colors.neutral[400],
        boxShadow: 'none',
      },
    },

    '&[data-focus-visible-added]:focus': {
      [`& ~ ${Content} ${Checkmark}`]: {
        ...(hideFocus
          ? {}
          : {
              borderColor: theme.colors.primary[500],
              boxShadow: `0 0 0 2px ${theme.colors.primary['300']}`,
            }),
      },
    },

    '&:checked': {
      '&:not(:disabled)': {
        [`& ~ ${Content} ${Checkmark}`]: {
          backgroundColor: theme.colors.primary[500],
          borderColor: theme.colors.primary[500],
        },
      },

      '&:disabled': {
        [`& ~ ${Content} ${Checkmark}`]: {
          backgroundColor: theme.colors.primary[500],
          borderColor: theme.colors.primary[500],
        },
      },

      [`& ~ ${Content} ${Checkmark}:after`]: {
        opacity: 1,
      },
    },
  },
}));
